import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog'
import { MatButton } from '@angular/material/button'
import { TranslationService } from '../../../services/translation.service'

type DATA = {
  title: string
  message: string
}

@Component({
  selector: 'app-dialog',
  imports: [MatButton],
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  dialogRef = inject<DialogRef<string>>(DialogRef)
  data = inject<DATA>(DIALOG_DATA)
  translationService = inject(TranslationService)
}
